import React, { useEffect, useState } from 'react';
import '../UploadFile.css';
import {
	RavenButton,
	RavenInputField,
	RavenTextTrim,
} from '@ravenpay/raven-bank-ui';
import { icons } from '../../../../../../../assets/icons';
import { useDispatch, useSelector } from 'react-redux';
import {
	validateCACRcNumber,
} from '../../../../../../../redux/cac';
import { RootState } from '../../../../../../../redux/store';
import { useLocation } from 'react-router-dom';
import {
	reactSelectStyle,
	removeSpace,
} from '../../../../../../../utils/helper/Helper';
import { bankboxAPI } from '../../../../../../../redux/bankbox';
import { debounce } from 'lodash';
import { ThreeDots } from 'react-loader-spinner';

export const formatMerkList = (param: any[]) => {
	if (Array.isArray(param) && param.length > 0) {
		return param.map((chi) => {
			const businessName = chi?.poseidon_business_name || '';
			const email = chi?.poseidon_email || '';

			return {
				...chi,
				label: (
					<div style={{ display: 'flex', flexDirection: 'column' }}>
						<span style={{ fontWeight: 600 }}>{businessName}</span>
						<span style={{ fontSize: '0.85em', color: 'gray' }}>{email}</span>
					</div>
				),
				value: businessName,
			};
		});
	}
	return [];
};

interface CacDetailsProps {
	setActiveTab: (tab: string) => void;
	rcNumber: string;
	setRcNumber: (param: string) => void;
	searchTerm: any;
	setSearchTerm: (param: string) => void;
	setbusinessEmail: (param: string) => void;
	setbusinessId: (param: string | number) => void;
}

const CacDetails = ({
	setActiveTab,
	rcNumber,
	setRcNumber,
	searchTerm,
	setSearchTerm,
	setbusinessEmail,
	setbusinessId,
}: CacDetailsProps) => {
	const [showDropdown, setShowDropdown] = useState<boolean>(false);
	const [selectedBusiness, setSelectedBusiness] = useState('');
	const [isEmailSearch, setIsEmailSearch] = useState(true);
	const [errorMessages, setErrorMessage] = useState('');
	const dispatch = useDispatch();

	const { validationResult, loading } =
		useSelector((state: RootState) => state.cac);

	const [selectedRcBusinessName, setSelectedRcBusinessName] = useState('');


	const location = useLocation();
	const prefillBusinessName = location?.state?.prefillBusinessName || '';
	const [selectedOption, setSelectedOption] = useState<any>(null);

	const { Biz } =
		useSelector((state: RootState) => state.bankbox);
	const options = formatMerkList(Biz);
	const selectValue =
		(selectedOption &&
			options.find((opt) => opt.value === selectedOption.value)) ||
		null;

	const cacFormatTypeObj = ({ value, label }: any) => {
		return (
			<div style={{ display: 'flex', flexDirection: 'column' }}>
				<span style={{ fontWeight: 600 }}>{label}</span>
				<span style={{ fontSize: '0.85em', color: 'gray' }}>{value}</span>
			</div>
		);
	};

	useEffect(() => {
		const savedRcName = localStorage.getItem('rc-name');
		if (savedRcName) {
			setSelectedRcBusinessName(savedRcName);
		}
	}, []);

	useEffect(() => {
		if (rcNumber === '') {
			localStorage.removeItem('rc-name');
		}
		localStorage.removeItem('selected-business');
	}, []);

	useEffect(() => {
		if (
			selectedRcBusinessName &&
			Array.isArray(validationResult) &&
			validationResult.length > 0
		) {
			const matched = validationResult.find(
				(b) => b.approved_name === selectedRcBusinessName
			);
			if (matched) {
				localStorage.setItem('selected-business', JSON.stringify(matched));
			}
		}
	}, [selectedRcBusinessName, validationResult]);

	useEffect(() => {
		if (prefillBusinessName && !searchTerm) {
			setSearchTerm(prefillBusinessName);
		}
	}, [prefillBusinessName, searchTerm, setSearchTerm]);

	useEffect(() => {
		if (removeSpace(String(rcNumber))?.length > 5) {
			dispatch(validateCACRcNumber({ rc_number: rcNumber }));
		}
	}, [rcNumber]);

	const handleContinue = () => {
		// Don't clear storage here
		setActiveTab('documents');
	};

	const rcName = localStorage.getItem('rc-name');

	const handleRcNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setRcNumber(e.target?.value);
		if (e.target?.value === '') {
			setSelectedRcBusinessName('');
			localStorage.removeItem('rc-name');
			setErrorMessage('');
		}
	};

	useEffect(() => {
		if (Biz?.length < 1) {
			dispatch(bankboxAPI.getMerBIZ({}));
		}
	}, []);

	return (
		<main
			// onClick={() => {
			// 	(Biz);
			// }}
			style={{ marginLeft: '5rem' }}
			className="main slide-in-right"
		>
			<p
				style={{ color: 'rgba(139, 139, 139, 1)', marginBottom: '1.5rem' }}
				className="section-title"
			>
				CAC DETAILS
			</p>
			<h1 className="form-title">Add Business RC Number</h1>

			<div style={{ marginRight: '16rem' }}>
				<RavenInputField
					selectOptionLabel={cacFormatTypeObj}
					color="black-light"
					label={isEmailSearch ? 'Merchant*' : 'Business Name'}
					type="select"
					selectOption={Biz}
					// selectValue={searchTerm}
					value={searchTerm}
					style={{ width: '100%', position: 'relative', zIndex: 100 }}
					selectStyles={reactSelectStyle}
					placeholder={`Select merchant`}
					onChange={(e: any) => {
						setSearchTerm(e);
						if (e?.poseidon_email) {
							setbusinessEmail(e.poseidon_email);
						}
						if (e?.id) {
							setbusinessId(e.id);
						}
					}}
				/>

				<RavenInputField
					style={{ width: '100%', marginTop: '3.5rem', marginBottom: '1rem' }}
					color="black-light"
					label="RC Number*"
					placeholder="Enter RC Number"
					value={rcNumber}
					labelClassName="my_custom_class"
					labelColor="purple-light"
					onChange={debounce((e: any) => {
						handleRcNumberChange(e);
						setSelectedRcBusinessName('');
						// setShowDropdown(false);
						setbusinessId('');
						localStorage.removeItem('selected-business');
						localStorage.removeItem('rc-name');
					}, 1000)}
					type="number"
				/>
				{/* {(debouncedRcNumber && selectedRcBusinessName) || rcName ? (
					<p
						style={{
							fontWeight: '700',
							fontSize: '1.2rem',
							marginTop: '0.5rem',
							marginBottom: '1rem',
						}}
					>
						{selectedRcBusinessName || rcName}
					</p>
				) : null} */}
				{/* Spinner only when loading_rc is true */}
				{loading && (
					<div
						style={{
							padding: '0rem',
							display: 'flex',
							justifyContent: 'flex-end',
							transform: 'translateX(1.5rem)',
						}}
						className="load-wrap"
					>
						<ThreeDots
							height="10"
							width="80"
							radius="9"
							color="var(--primary-base-color)"
							ariaLabel="three-dots-loading"
							visible={true}
						/>
					</div>
				)}

				{/* Dropdown only AFTER loading completes */}
				{!loading && rcNumber && (
					<ul
						style={{
							marginTop: '2rem',
						}}
						className="business-dropdown open"
					>
						{Array.isArray(validationResult) && validationResult.length > 0 ? (
							validationResult.map((business) => (
								<li
									key={business?.rc_number}
									className={`business-item ${
										(selectedRcBusinessName || rcName) ===
										business.approved_name
											? 'selected'
											: ''
									}`}
									onClick={() => {
										const isSelected =
											selectedRcBusinessName === business?.approved_name;
										setSelectedRcBusinessName(
											isSelected ? '' : business?.approved_name
										);
										setShowDropdown(!isSelected);
										setbusinessId(isSelected ? '' : business?.id);

										if (!isSelected) {
											localStorage.setItem(
												'selected-business',
												JSON.stringify(business)
											);
											localStorage.setItem('rc-name', business.approved_name);
										} else {
											localStorage.removeItem('selected-business');
											localStorage.removeItem('rc-name');
										}
									}}
								>
									<div className="business-name">
										{RavenTextTrim(business?.approved_name, 32)}
									</div>
									{(selectedRcBusinessName || rcName) ===
										business.approved_name && (
										<div className="check-icon">
											<figure>{icons?.checkicon}</figure>
										</div>
									)}
								</li>
							))
						) : (
							<li className="business-item no-result">
								<span>No results available</span>
							</li>
						)}
					</ul>
				)}

				<RavenButton
					style={{ marginTop: '3.5rem' }}
					label="Continue"
					onClick={handleContinue}
					color="deep-green-dark"
					disabled={!searchTerm || !selectedRcBusinessName}
				/>
			</div>
		</main>
	);
};

export default CacDetails;
